// src/pages/HomePage.js
import React from 'react';
import Header from '../components/Header';
import { useNavigate } from 'react-router-dom';

function HomePage() {
  const navigate = useNavigate();

  // Define navigation options with icons
  const navOptions = [
    // {
    //   path: '/gallery',
    //   label: 'Gallery',
    //   icon: '🖼️',
    //   description: 'View your photo collection'
    // },
    // {
    //   path: '/mood',
    //   label: 'Mood',
    //   icon: '🎵',
    //   description: 'Listen to audio messages'
    // },
    {
      path: '/chat',
      label: 'Chat',
      icon: '💬',
      description: 'Send and receive messages'
    },
    {
      path: '/sos',
      label: 'Send Notification',
      icon: '🆘',
      description: 'Send emergency notifications'
    }
  ];

  return (
    <>
      <Header />
      <div className="home-container">
        <h2>Welcome</h2>
        <div className="options-container">
          {navOptions.map((option, index) => (
            <button 
              key={index} 
              onClick={() => navigate(option.path)}
              className="home-nav-button"
            >
              <span className="nav-icon">{option.icon}</span>
              <div className="nav-content">
                <span className="nav-label">{option.label}</span>
                <span className="nav-description">{option.description}</span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </>
  );
}

export default HomePage;
